/* correctez-home.js (2026-07-22)
   Homepage/non-product runtime for the crtz-* bsx sections, extracted
   verbatim from correctez.js (which top-level-crashes off the product
   page: unguarded #mainImgBtn gallery wiring). Blocks: reveal-on-scroll,
   before/after slider, recovery carousel, doctor marquee, count-up
   tickers. Each block is isolated in try/catch so a missing widget can
   never blank the rest of the page. Do NOT load correctez.js alongside
   this on non-product pages. */
(function () {
  'use strict';

  /* ---- reveal ---- */
  try {
// Reveal on scroll
    const io = new IntersectionObserver((entries) => {
      for (const e of entries) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      }
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.reveal').forEach(el => io.observe(el));
  } catch (e) { console.warn('cz-home:%s', 'reveal', e); }

  /* ---- before-after ---- */
  try {
// Before/After slider
    const ba       = document.getElementById('ba');
    const baLayer  = ba.querySelector('.layer-after');
    const baHandle = document.getElementById('baHandle');
    let dragging = false;
    const setSplit = (clientX) => {
      const r = ba.getBoundingClientRect();
      const pct = Math.max(2, Math.min(98, ((clientX - r.left) / r.width) * 100));
      baLayer.style.clipPath = `inset(0 0 0 ${pct}%)`;
      baHandle.style.left = pct + '%';
    };
    ba.addEventListener('pointerdown', (e) => { dragging = true; setSplit(e.clientX); ba.setPointerCapture(e.pointerId); });
    ba.addEventListener('pointermove', (e) => { if (dragging) setSplit(e.clientX); });
    ba.addEventListener('pointerup', () => dragging = false);
    ba.addEventListener('pointercancel', () => dragging = false);
  } catch (e) { console.warn('cz-home:%s', 'before-after', e); }

  /* ---- carousel ---- */
  try {
// Engineered-recovery slider: auto-rotate between profiles, pause on hover/touch
    (() => {
      const stage = document.getElementById('recoveryStage');
      if (!stage) return;
      const slides = [...stage.querySelectorAll('.recovery-slide')];
      const dots   = [...stage.querySelectorAll('.recovery-dot')];
      if (slides.length < 2) return;

      let i = 0;
      let timer;
      const showSlide = (next) => {
        i = (next + slides.length) % slides.length;
        slides.forEach((s, idx) => s.classList.toggle('is-active', idx === i));
        dots.forEach((d, idx)   => d.classList.toggle('is-active', idx === i));
        // Re-trigger entrance animations on left/right pill columns
        slides[i].querySelectorAll('.slide-in-l, .slide-in-r').forEach(el => {
          el.style.animation = 'none';
          // eslint-disable-next-line no-unused-expressions
          el.offsetWidth;
          el.style.animation = '';
        });
      };
      const tick = () => showSlide(i + 1);
      const start = () => { stop(); timer = setInterval(tick, 5500); };
      const stop  = () => { if (timer) clearInterval(timer); timer = null; };

      dots.forEach((d) => d.addEventListener('click', () => {
        showSlide(+d.dataset.dot);
        start(); // reset cadence after manual change
      }));

      stage.addEventListener('pointerenter', stop);
      stage.addEventListener('pointerleave', start);
      stage.addEventListener('pointerdown', stop);
      stage.addEventListener('pointerup',   start);

      // Only run when in view (saves CPU + no surprise jumps if user scrolls back)
      const io = new IntersectionObserver(([e]) => { e.isIntersecting ? start() : stop(); }, { threshold: 0.25 });
      io.observe(stage);
    })();
  } catch (e) { console.warn('cz-home:%s', 'carousel', e); }

  /* ---- marquee ---- */
  try {
// Doctor marquee: pause on touch/pointerdown (CSS :hover already handles desktop)
    const docMarq = document.getElementById('docMarquee');
    if (docMarq) {
      let pauseTimer;
      const pause   = () => { docMarq.classList.add('paused'); clearTimeout(pauseTimer); };
      const resume  = () => {
        clearTimeout(pauseTimer);
        // Hold the pause briefly after the touch ends so users have time to read
        pauseTimer = setTimeout(() => docMarq.classList.remove('paused'), 1200);
      };
      docMarq.addEventListener('pointerdown', pause);
      docMarq.addEventListener('pointerup',   resume);
      docMarq.addEventListener('pointercancel', resume);
      docMarq.addEventListener('pointerleave',  resume);
    }
  } catch (e) { console.warn('cz-home:%s', 'marquee', e); }

  /* ---- tickers ---- */
  try {
// Count-up tickers
    const countObs = new IntersectionObserver((entries) => {
      for (const e of entries) {
        if (!e.isIntersecting) continue;
        const el = e.target;
        const target = parseInt(el.dataset.target || '0', 10);
        const suffix = el.querySelector('span')?.outerHTML || '';
        const dur = 1400;
        const t0 = performance.now();
        const tick = (t) => {
          const k = Math.min(1, (t - t0) / dur);
          const eased = 1 - Math.pow(1 - k, 3);
          let v = Math.round(target * eased);
          if (target >= 1000) v = v.toLocaleString();
          el.innerHTML = v + suffix;
          if (k < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
        countObs.unobserve(el);
      }
    }, { threshold: 0.3 });
    document.querySelectorAll('.ticker[data-target]').forEach(el => countObs.observe(el));
  } catch (e) { console.warn('cz-home:%s', 'tickers', e); }
})();
